import Footer from './desktop/Footer';
import FooterMobile from './mobile/FooterMobile';
import 'portalConfig';

export default angular.module('edge.platform.widgets.footer', ['portal.config'])
    .component('gwFooter', Footer)
    .component('gwFooterMobile', FooterMobile);
